import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomNgbModalService extends NgbModal {
    // Default options for all modals
    protected defaultOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
    };
    
    open(content: any, options: NgbModalOptions = {}): NgbModalRef {
        // Merge custom options with default options
        const mergedOptions = { ...this.defaultOptions, ...options };
        return super.open(content, mergedOptions);
    }
}
